import * as React from "react"
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import styled from "styled-components"
import HeroCover from "../components/HeroCover/HeroCover"
import parse from "html-react-parser"

const FoodBoxHeader = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  
  padding: 0 0 0 60px;
  border-bottom: 1px solid #e0e0e0;;
  cursor: pointer;
  
  @media (max-width: 600px) {
    padding: 16px;
  }

  & img {
    width: 20%;
    object-fit: cover;
  }
  
  & span {
    font-style: italic;
    opacity: 50%;
    margin: 0 30px;
  }
`

const FoodBoxContent = styled.div`
  padding: ${({ open }) => open ? "60px" : "0px"};

  & div {
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    
    & p {
      width: 80%;
    }

    & img {
      width: 100%;
      object-fit:cover;
    }
  }
`

export const FoodBox = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-bottom: 36px;
`

const FoodItem = ({ name, description, image, price }) => {

  const [open, setOpen] = React.useState(false)

  return(
    <FoodBox>
      <FoodBoxHeader onClick={() => setOpen(!open)}>
        <h4>[{open ? "-" : "+"}] {name}</h4>
        <span>(₱{price})</span>
        <img src={image} height="150"/>
      </FoodBoxHeader>
      <FoodBoxContent open={open}>
        {
          open
          ?
          <div>
            <p>{parse(description)}</p>
            <img src={image} height="200"/>
          </div>
          :
          null
        }
      </FoodBoxContent>
    </FoodBox>
  )
}

const MenuContainer = ({ foodItems }) => {

  return(
    <div>
      {foodItems.map(foodItem => {
        const { food_name, description, price, image } = foodItem.food_item.document.data
        return(
          <FoodItem
            name={food_name.text}
            description={description.html}
            price={price.text}
            image={image.url}
          />
        )
      })}
    </div>
  )
}

const BrewPage = ({ data }) => {
  const dataSet = data.allPrismicBrewPage.edges[0].node.data
  const { title, description, backround_image, food_items } = dataSet

  return (
    <Layout>
      <HeroCover
        title={title.text}
        description={description.text}
        image={backround_image.url}
      />
      <div className="headings">
        <h2>Menu</h2>
        <p>Scroll through the different items we have on our menu</p>
      </div>
      <MenuContainer foodItems={food_items} />
    </Layout>
  )
}

export const query = graphql`
  {
    allPrismicBrewPage {
      edges {
        node {
          data {
            title {
              text
            }
            backround_image {
              url
            }
            food_items {
              food_item {
                document {
                  ... on PrismicBrewFoodItems {
                    id
                    data {
                      price {
                        text
                      }
                      image {
                        url
                      }
                      food_name {
                        text
                      }
                      description {
                        html
                      }
                    }
                  }
                }
              }
            }
            description {
              text
            }
          }
        }
      }
    }
  }
`

export default BrewPage
